// src/reducers/libraryCardReducer.js
// Generic DDB store reducer — shared by brand kit, theme bootstrapper, etc.
import {
  GET_LIBRARY_CARD_REQUEST,
  GET_LIBRARY_CARD_SUCCESS,
  GET_LIBRARY_CARD_FAILURE,
  UPDATE_LIBRARY_CARD_REQUEST,
  UPDATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_FAILURE,
  REQUEST_PRESIGNED_URL,
  REQUEST_PRESIGNED_URL_SUCCESS,
  REQUEST_PRESIGNED_URL_FAILURE,
} from "../actions/types";

const initialState = {
  loading: false,
  data: null,
  presignedUrl: null,
  error: null,
};

const libraryCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIBRARY_CARD_REQUEST:
    case UPDATE_LIBRARY_CARD_REQUEST:
    case REQUEST_PRESIGNED_URL:
      return { ...state, loading: true, error: null };

    case GET_LIBRARY_CARD_SUCCESS:
    case UPDATE_LIBRARY_CARD_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case REQUEST_PRESIGNED_URL_SUCCESS:
      return { ...state, loading: false, presignedUrl: action.payload };

    case GET_LIBRARY_CARD_FAILURE:
    case UPDATE_LIBRARY_CARD_FAILURE:
    case REQUEST_PRESIGNED_URL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default libraryCardReducer;
